import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { submitFeedback } from '../../features/modals/ducks';
import { logOut } from '~actions/rootActions';

import headerIcon from '~images/request_permissions.svg';

import { ModalWrapper, FormLabel, Select, Gap, Textarea } from '~ui-kit';

const OnboardingSelectPage = () => {
  const dispatch = useDispatch();
  const [organization, setOrganization] = useState(null);
  const [comment, setComment] = useState('');
  const onHide = () => {
    dispatch(logOut);
  };

  const organizations = useSelector(state => state.reducer.organizations);
  const organizationOptions = organizations.map(organization => ({
    value: organization.id,
    label: organization.name,
  }));

  const navigate = useNavigate();

  const handleSubmit = () => {
    dispatch(
      submitFeedback({
        comment,
        type: 'MESSAGE_ACCESS_PERMISSIONS',
        unit: organization?.value,
      })
    );
    navigate('/onboarding/valmis');
  };

  return (
    <Container>
      <ModalWrapper
        close={onHide}
        title="Pyydä oikeus yksikköön"
        backText="Sulje paketti"
        backOnClick={() => navigate('/onboarding/lupa')}
        confirmText="Lähetä pyyntö"
        confirmOnClick={handleSubmit}
        confirmDisable={!organization}
        headerLargeIcon={headerIcon}
      >
        <p>Palvelukoordinaattorimme reagoi viestiisi pikimmiten.</p>
        <FormLabel>Yksikkö, jolle haluat luvan</FormLabel>
        <Select
          value={organization}
          options={organizationOptions}
          onChange={setOrganization}
          placeholder="Valitse yksikkö nimellä"
        />
        <Gap />
        <FormLabel>Kommentti</FormLabel>
        <Textarea
          value={comment}
          onChange={setComment}
          placeholder="Tarvittaessa esim. lisätietoja"
        />
      </ModalWrapper>
    </Container>
  );
};

const Container = styled.div``;

export default OnboardingSelectPage;
